<template>
  <div id="pageDashboard" class="container">
    <v-container grid-list-xl fluid>
      <h3 class="bem-vindo">Bem-vindo ao seu ambiente de estudos</h3>
      <v-flex class="fill-height" style="max-width: 720px">
        <iframe
          id="panda-7166f139-c127-4fbb-8b24-d71239e209ff"
          src="https://player-vz-6b763bac-40b.tv.pandavideo.com.br/embed/?v=7166f139-c127-4fbb-8b24-d71239e209ff"
          class="video-bem-vindo"
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
          allowfullscreen="true"
          width="100%"
          height="415"
          fetchpriority="high"
        >
        </iframe>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import Material from "vuetify/es5/util/colors";
// import BoxChart from '@/components/widgets/chart/BoxChart'
// import CircleStatistic from '@/components/widgets/statistic/CircleStatistic'
// import LinearStatistic from '@/components/widgets/statistic/LinearStatistic'
export default {
  components: {},
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data: () => ({
    color: Material,
    selectedTab: "tab-1",
    linearTrending: [
      {
        subheading: "Sales",
        headline: "2,55",
        caption: "increase",
        percent: 15,
        icon: {
          label: "trending_up",
          color: "success",
        },
        linear: {
          value: 15,
          color: "success",
        },
      },
      {
        subheading: "Revenue",
        headline: "6,553",
        caption: "increase",
        percent: 10,
        icon: {
          label: "trending_down",
          color: "error",
        },
        linear: {
          value: 15,
          color: "error",
        },
      },
      {
        subheading: "Orders",
        headline: "5,00",
        caption: "increase",
        percent: 50,
        icon: {
          label: "arrow_upward",
          color: "info",
        },
        linear: {
          value: 50,
          color: "info",
        },
      },
    ],
    trending: [
      {
        subheading: "Email",
        headline: "15+",
        caption: "email opens",
        percent: 15,
        icon: {
          label: "email",
          color: "info",
        },
        linear: {
          value: 15,
          color: "info",
        },
      },
      {
        subheading: "Tasks",
        headline: "90%",
        caption: "tasks completed.",
        percent: 90,
        icon: {
          label: "list",
          color: "primary",
        },
        linear: {
          value: 90,
          color: "success",
        },
      },
      {
        subheading: "Issues",
        headline: "100%",
        caption: "issues fixed.",
        percent: 100,
        icon: {
          label: "bug_report",
          color: "primary",
        },
        linear: {
          value: 100,
          color: "error",
        },
      },
    ],
  }),
  computed: {},
  metaInfo: {
    // Children can override the title.
    title: "Prof Lucas Silva",
    // Result: My Page Title ← My Site
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: "%s ← Home",
    // Define meta tags here.
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Ambiente de estudos para transformar você em um Certificado Anbima CPA-10, CPA-20, Ancord, CEA e CFP",
      },
      {
        name: "keywords",
        content:
          "Certificação, Anbima, CPA-10, CPA-20, Ancord, CEA, CFP, Dicas, Estudos",
      },
    ],
  },
};
</script>
<style scoped lang="scss">
.bem-vindo {
  line-height: 1.1;
  margin-bottom: 15px;
}
.video-bem-vindo {
  border-style: none;
  order: 3;
  @media (max-width: 727px) {
    position: absolute;
    left: 0;
  }
}
</style>
